import React from 'react';
import CircularProgressbar from 'react-circular-progressbar';
import './NumberWidgetCircular.scss';
import NumberFormatter from '../../lib/numberFormatter';
import customNumber from '../../lib/customNumberFormatter';

// TODO: Ensure that the budget is set
class NumberWidgetCircular extends React.Component {
    render() {
        const { widget, widgetData, isThumbnail } = this.props;

        let value = 0;
        let budget = 0;

        if (widgetData) {
            if (widgetData.length > 0) {
                let totalValue = 0;
                let totalBudget = 0;
                for (let i = 0; i < widgetData.length; i++) {
                    totalValue += widgetData[i].value;
                    totalBudget += widgetData[i].budget;
                }

                value = Math.floor(totalValue);
                budget = Math.floor(totalBudget);
            } else if (widgetData.length === 0) {
                if (widgetData[0] && widgetData[0]) {
                    value = widgetData[0].value;
                    budget = widgetData[0].budget;
                }
            } else {
                console.log('this is strange, nothing loaded from cache.');
            }
        }

        if (widget.displayConfig && widget.displayConfig.budget) {
            if (widget.displayConfig.budget != null || 0 || '') {
                budget = parseInt(widget.displayConfig.budget, 10);
            }
        }


        const _value = NumberFormatter.shortenLargeNumber(value, 2);
        const _budget = NumberFormatter.shortenLargeNumber(budget);

        let percent = Math.floor(((value / budget) * 100));

        if (percent > 100) percent = 100;

        let className = `widgetContainer ${widget.dataType}`;

        if (percent >= 100) {
            className += ' budget_achieved_circularwidget';
      // percent = 100;
        }

        if (isThumbnail) {
            return (<div className={className} />)
        }

        let unit;
        let typeClassName = '';
        let unitClassName = 'suffix';
        if (widget.dataType === 'closedSales' || widget.dataType === 'sales') {
            unit = `/ ${NumberFormatter.shortenLargeNumber(budget, 2)}`;
            unitClassName += ' sales';
            typeClassName = 'sales';
        } else if (widget.dataType === 'meetings' || widget.dataType === 'bookedMeetings') {
            unit = `/${_budget}`;
            unitClassName += ' meetings';
            typeClassName = 'meetings';
        }

        return (
            <div className={className}>
                <i className="fa fa-check" />
                <div className="number_circle_widget">
                    <div className="circularContainer">
                        <CircularProgressbar
                            initialAnimation={true}
                            percentage={percent}
                            classForPercentage={(percentage) => (
                                percentage === 100 ? 'complete' : 'incomplete'
                            )}
                            textForPercentage={() => {
                                if (widget.dataType === 'closedSales' ||
                                    widget.dataType === 'sales') {
                                    return (
                                        <tspan className={typeClassName}>
                                            <tspan
                                                x="50"
                                                dy="-5"
                                                className="text_percentage_wrapper"
                                            >
                                                {_value}
                                            </tspan>
                                            <tspan
                                                x="50"
                                                dy="15"
                                                className={unitClassName}
                                                style={{ display: 'none' }}
                                            >
                                                {unit}
                                            </tspan>
                                        </tspan>
                                    );
                                } else {
                                    return (
                                        <tspan x="50" dy="3" className={typeClassName}>
                                            <tspan className="text_percentage_wrapper">
                                                {_value}
                                            </tspan>
                                            <tspan
                                                style={{ display: 'none' }}
                                                className={unitClassName}
                                            >
                                                {unit}
                                            </tspan>
                                        </tspan>
                                    );
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

NumberWidgetCircular.propTypes = {
    widget: React.PropTypes.object,
    widgetData: React.PropTypes.array,
};

export default NumberWidgetCircular;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/NumberWidgetCircular.jsx
 **/